<template>
    <div class="relative z-[99999]" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm transition-opacity"></div>
        <div class="fixed inset-0 z-30 overflow-y-auto">
            <div class="flex min-h-full items-end px-4 pb-16 text-center max-w-lg mx-auto">
                <div
                    class="border-2 border-jackpot-bg flex-1 relative transform overflow-hidden rounded-lg text-left drop-shadow-xl transition-all">

                    <div class="bg-white dark:bg-global-bg p-4 modalheight overflow-y-auto">

                        <div class="text-center mb-2">
                            <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-gray-50">Spin Wheel</h3>
                            <p>Get a chance to win some wonderful prizes!</p>
                            <p class="text-sm text-green-500 font-semibold flex items-center justify-center gap-2 mt-2"
                                v-if="status !== ''">
                                <span>{{ status }}</span>
                                <spinner class="text-green-500" />
                            </p>
                            <p class="text-sm text-red-500 font-semibold flex items-center justify-center gap-2 mt-2"
                                v-if="statusError !== ''">
                                <span>{{ statusError }}</span>
                            </p>
                            <p class="text-sm text-transparent font-semibold flex items-center justify-center gap-2 mt-2"
                                v-if="statusError == '' && status == ''">
                                <span>&nbsp;</span>
                            </p>
                        </div>

                        <div v-if="!tokenSelected" class="flex flex-col items-center justify-center gap-2">
                            <p v-if="!tokenSelected" class="text-inner-border text-sm mb-2">Select a Gem to Play</p>
                            <div class="flex items-center justify-center gap-1">
                                <div class="flex flex-col items-center justify-center gap-1">
                                    <div class="text-gray-200 text-xs flex items-center gap-1">
                                        <div>Topaz</div>
                                        <div class="text-gray-400">({{ topaz.length }})</div>
                                    </div>
                                    <img @click="selectToken('topaz')" class="h-16 w-16 rounded drop-shadow-sm"
                                        src="/images/token_topaz.gif" />
                                </div>
                                <div class="flex flex-col items-center justify-center gap-1">
                                    <div class="text-gray-200 text-xs flex items-center gap-1">
                                        <div>Sapphire</div>
                                        <div class="text-gray-400">({{ sapphire.length }})</div>
                                    </div>
                                    <img @click="selectToken('sapphire')" class="h-16 w-16 rounded drop-shadow-sm"
                                        src="/images/token_sapphire.gif" />
                                </div>
                                <div class="flex flex-col items-center justify-center gap-1">
                                    <div class="text-gray-200 text-xs flex items-center gap-1">
                                        <div>Emerald</div>
                                        <div class="text-gray-400">({{ emerald.length }})</div>
                                    </div>
                                    <img @click="selectToken('emerald')" class="h-16 w-16 rounded drop-shadow-sm"
                                        src="/images/token_emerald.gif" />
                                </div>
                                <div class="flex flex-col items-center justify-center gap-1">
                                    <div class="text-gray-200 text-xs flex items-center gap-1">
                                        <div>Ruby</div>
                                        <div class="text-gray-400">({{ ruby.length }})</div>
                                    </div>
                                    <img @click="selectToken('ruby')" class="h-16 w-16 rounded drop-shadow-sm"
                                        src="/images/token_ruby.gif" />
                                </div>
                            </div>
                        </div>

                        <div v-if="tokenSelected && !spin.ready" class="flex flex-col items-center gap-1 mx-auto w-48">
                            <div class="text-sm text-inner-border">{{ type.charAt(0).toUpperCase() + type.slice(1) }} Prize
                                List</div>
                            <div v-for="prize in prizes[type]"
                                class="flex items-center justify-between gap-1 text-xs uppercase px-2 py-1 rounded bg-[#383e42] text-white w-full">
                                <span>{{ prize.name }}</span>
                                <img :src="'/images/prize-' + prize.prize + '.png'" class="h-6 w-6 block" />
                            </div>
                        </div>

                        <div v-show="spin.ready" class="flex flex-col items-center justify-center">
                            <div class="relative flex items-center justify-center slots"
                                :style="`padding: ${slot_padding}px`">
                                <div ref="reel" class="reel"
                                    :style="`width: ${icon_width}px; height: ${slot_height}px; background-image: url(${slot_bg});`">
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="bg-gray-50 dark:bg-global-bg px-4 py-3 flex flex-col">
                        <button v-if="tokenSelected" @click.prevent="spinToken(type)" :disabled="!canRoll(type) || rolling"
                            type="button" class="modal-action-button">
                            <span v-if="rolled == 0">Spin</span>
                            <span v-else>Spin Again</span>
                            <span class="text-xs">({{ canRoll(type) }})</span>
                        </button>
                        <button @click.prevent="closeOrBack" type="button" :disabled="(spin.ready && !ended) || rolling"
                            class="modal-cancel-button">
                            <span v-if="type !== ''">Back</span>
                            <span v-else>Close</span>
                        </button>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { Connection, PublicKey, TransactionMessage, VersionedTransaction } from "@solana/web3.js"
import { bs58 } from "@project-serum/anchor/dist/cjs/utils/bytes/index.js"
import { SPL_ACCOUNT_COMPRESSION_PROGRAM_ID, SPL_NOOP_PROGRAM_ID } from "@solana/spl-account-compression"
import { createTransferInstruction, PROGRAM_ID as BUBBLEGUM_PROGRAM_ID } from "@metaplex-foundation/mpl-bubblegum"
import { useWallet } from 'solana-wallets-vue'

export default {
    name: 'SpinModal',
    props: ['token', 'spin'],
    data() {
        return {
            rpc: null,
            connection: null,
            tokens: [],
            fetchingTokens: false,
            ended: false,
            rolled: 0,
            rolling: false,
            status: '',
            statusError: '',
            prizes: [],
            icon_width: 200,
            icon_height: 35,
            time_per_icon: 100,
            type: '',
            slot_bg: '',
            iconMap: []
        }
    },
    async mounted() {
        this.$emit('spin-reset')
        this.rpc = process.env.MIX_TOKEN_RPC
        this.connection = new Connection(this.rpc)
        await this.fetchPrizes()
        await this.fetchWalletTokens()
    },
    watch: {
        spin: {
            handler(value) {
                if (value.prize !== '') {
                    this.roll(value.prize)
                }
            },
            deep: true
        }
    },
    computed: {
        tokenSelected() {
            return this.type !== ''
        },
        slot_width() {
            return 1.05 * this.icon_width
        },
        slot_height() {
            return 3 * this.icon_height
        },
        slot_padding() {
            return 0.25 * this.icon_height
        },
        num_icons() {
            return this.iconMap.length
        },
        topaz() {
            return this.tokens.filter(item => item.compression.tree === process.env.MIX_TOKEN_TOPAZ)
        },
        sapphire() {
            return this.tokens.filter(item => item.compression.tree === process.env.MIX_TOKEN_SAPPHIRE)
        },
        emerald() {
            return this.tokens.filter(item => item.compression.tree === process.env.MIX_TOKEN_EMERALD)
        },
        ruby() {
            return this.tokens.filter(item => item.compression.tree === process.env.MIX_TOKEN_RUBY)
        }
    },
    methods: {
        selectToken(type) {
            if (this.fetchingTokens) {
                return
            }
            this.type = type
            this.iconMap = this.prizes[type].map((item) => item.slug)
            this.slot_bg = '/images/slot-' + type + '-lowres.jpg'
        },
        deselectToken() {
            if (this.fetchingTokens) {
                return
            }
            this.$emit('spin-reset')
            this.type = ''
            this.iconMap = []
            this.slog_bg = ''
        },
        closeOrBack() {
            if (this.type !== '') {
                this.deselectToken()
                return
            }
            this.emitter.emit('close-modal', 'spin_modal')
        },
        canRoll(type) {
            return this.$options.computed[type].call(this).length
        },
        async fetchPrizes() {
            try {
                await window.axios.post('/api/account/spin/prizes', {}, {
                    headers: {
                        'Authorization': `Bearer ${this.token}`
                    }
                }).then((res) => {
                    this.prizes = res.data.prizes
                })
            } catch (err) {
                console.log(err.message)
                throw new Error('Error confirming spin. Try again later...')
            }
        },
        fetchWalletTokens(rpcUrl = process.env.MIX_TOKEN_RPC) {
            this.fetchingTokens = true
            this.status = "Fetching gems..."
            const collection = process.env.MIX_TOKEN_COLLECTION
            const wallet = useWallet().publicKey.value.toString()
            let page = 1
            axios.post(rpcUrl, {
                jsonrpc: '2.0',
                id: 'my-id',
                method: 'searchAssets',
                params: {
                    ownerAddress: wallet,
                    compressed: true,
                    grouping: ["collection", collection],
                    page: page,
                    limit: 1000
                }
            }).then((response) => {
                this.tokens = response.data.result.items
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                this.fetchingTokens = false
                this.status = ''
            })
        },
        decode(stuff) {
            return this.bufferToArray(bs58.decode(stuff))
        },
        bufferToArray(buffer) {
            const nums = []
            for (let i = 0; i < buffer.length; i++) {
                nums.push(buffer[i])
            }
            return nums
        },
        mapProof(assetProof) {
            if (!assetProof.proof || assetProof.proof.length === 0) {
                throw new Error('Proof is empty');
            }
            return assetProof.proof.map((node) => ({
                pubkey: new PublicKey(node),
                isSigner: false,
                isWritable: false,
            }))
        },
        async getAssetProof(assetId, rpcUrl = process.env.MIX_TOKEN_RPC) {
            try {
                const response = await axios.post(rpcUrl, {
                    jsonrpc: "2.0",
                    method: "getAssetProof",
                    id: "my-id",
                    params: {
                        id: assetId
                    },
                });
                return response.data.result;
            } catch (error) {
                console.error(error);
            }
        },
        async transferCNFTix(asset, signer, newOwner, assetProof) {
            const [treeAuthority, _bump] = PublicKey.findProgramAddressSync(
                [asset.merkleTree.toBuffer()],
                BUBBLEGUM_PROGRAM_ID,
            )
            const canopyDepth = 8
            const proofPathAsAccounts = this.mapProof(assetProof).slice(0, assetProof.proof.length - canopyDepth)

            return await createTransferInstruction({
                treeAuthority: treeAuthority,
                leafOwner: signer,
                leafDelegate: signer,
                newLeafOwner: newOwner,
                merkleTree: asset.merkleTree,
                logWrapper: SPL_NOOP_PROGRAM_ID,
                compressionProgram: SPL_ACCOUNT_COMPRESSION_PROGRAM_ID,
                anchorRemainingAccounts: proofPathAsAccounts
            },
                {
                    creatorHash: this.decode(asset.creator_hash),
                    dataHash: this.decode(asset.data_hash),
                    index: asset.leaf_id,
                    nonce: asset.leaf_id,
                    root: this.decode(assetProof.root)
                })
        },
        async createTx(instructions, signer, latestBlockhash) {
            const messageLegacy = new TransactionMessage({
                payerKey: signer,
                recentBlockhash: latestBlockhash.blockhash,
                instructions
            }).compileToLegacyMessage()
            return new VersionedTransaction(messageLegacy)
        },
        async spinToken(type) {
            if (this.rolled) {
                this.$emit('spin-reset');
            }
            this.status = ''
            this.statusError = ''
            this.rolling = true
            try {
                const newOwner = new PublicKey(process.env.MIX_TOKEN_WALLET)
                const signer = useWallet().publicKey.value

                const tokens = this.$options.computed[type].call(this).slice(0, 1).map((token) => {
                    return {
                        id: token.id,
                        creator_hash: token.compression.creator_hash,
                        data_hash: token.compression.data_hash,
                        merkleTree: new PublicKey(token.compression.tree),
                        leaf_id: token.compression.leaf_id,
                    }
                })

                const assetId = tokens[0].id

                this.status = 'Preparing gem for spin...'
                let assetProof
                try {
                    assetProof = await this.getAssetProof(assetId)
                } catch (err) {
                    throw new Error('Error Getting Asset Proof. Try again later...')
                }

                const ix = await this.transferCNFTix(tokens[0], signer, newOwner, assetProof)

                this.status = 'Getting latest blockash...'
                let latestBlockhash
                try {
                    latestBlockhash = await this.connection.getLatestBlockhash()
                } catch (err) {
                    console.log(err.message)
                    throw new Error('Error getting latest blockash. Try again later...')
                }

                this.status = 'Generating transaction...'
                let tx
                try {
                    tx = await this.createTx([ix], signer, latestBlockhash)
                } catch (err) {
                    console.log(err.message)
                    throw new Error('Error generating transaction. Try again later...')
                }

                this.status = 'Waiting for wallet to sign transaction...'
                const { sendTransaction } = useWallet()
                let signature
                try {
                    signature = await sendTransaction(tx, this.connection, { preflightCommitment: 'confirmed' })
                    console.log('tx:', signature)

                    let confirmed = false

                    this.status = 'Waiting for spin...'
                    try {
                        window.axios.post('/api/account/spin/confirm', {
                            'tx': signature,
                            'confirmed': confirmed,
                            'type': type
                        }, {
                            headers: {
                                'Authorization': `Bearer ${this.token}`
                            }
                        })
                        this.$emit('spin-ready')
                    } catch (err) {
                        console.log(err.message)
                        throw new Error('Error confirming spin. Try again...')
                    }
                } catch (err) {
                    this.rolling = false
                    console.log(err.message)
                    throw new Error(err.message)
                }
            } catch (err) {
                console.log(err)
                this.status = ''
                this.statusError = 'Error confirming spin. Try again...'
                this.$toast.error(err.message)
            } finally {
                if (!this.spin.ready) {
                    this.status = ''
                }
            }
        },
        async roll(target) {
            const reel = this.$refs.reel
            reel.style.backgroundPositionY = 0
            const currentIconIndex = 0
            const index = this.iconMap.indexOf(target)
            const distanceToTarget = (index + this.num_icons - currentIconIndex) % this.num_icons
            const delta = 10 * this.num_icons + distanceToTarget
            return new Promise((resolve, reject) => {
                const style = getComputedStyle(reel)
                const backgroundPositionY = parseFloat(style["background-position-y"])
                const targetBackgroundPositionY = backgroundPositionY + delta * this.icon_height
                const normTargetBackgroundPositionY = targetBackgroundPositionY % (this.num_icons * this.icon_height)
                setTimeout(() => {
                    this.status = ''
                    reel.style.transition = `background-position-y ${(8 + 1 * delta) * this.time_per_icon}ms cubic-bezier(.41,-0.01,.63,1.09)`
                    reel.style.backgroundPositionY = `${backgroundPositionY + delta * this.icon_height}px`
                }, 0);

                setTimeout(() => {
                    this.rolling = false
                    this.ended = true
                    this.rolled = this.rolled + 1
                    reel.style.transition = `none`
                    reel.style.backgroundPositionY = `${normTargetBackgroundPositionY}px`
                    this.fetchWalletTokens()
                    resolve(index)
                }, (8 + 1 * delta) * this.time_per_icon)
            })
        }
    }
}
</script>
